import { type ReactNode } from 'react';
import { type VotingType } from '../../../common/core-api';
import { IdeaVoteBox } from './IdeaVoteBox';
import { IdeaCommentCount } from './IdeaCommentCount';
import * as Styled from './IdeaCard.styled';

interface IdeaFooterProps {
  readonly voteCount: number | null;
  readonly score?: number | null;
  readonly commentCount: number;
  readonly votingType?: VotingType | null;
  readonly isBlindVoting?: boolean;
  readonly canModerate?: boolean;
  readonly voteLabel?: string;
  readonly showThumbsUp?: boolean;
  readonly maxStars?: number;
  readonly prefix?: ReactNode;
  readonly suffix?: ReactNode;
}

export const IdeaFooter = ({
  voteCount,
  score,
  commentCount,
  votingType,
  isBlindVoting,
  canModerate,
  voteLabel,
  showThumbsUp,
  maxStars,
  prefix,
  suffix
}: IdeaFooterProps) => (
  <Styled.Footer>
    <Styled.VoteSection>
      {prefix}
      <IdeaVoteBox
        voteCount={voteCount}
        score={score}
        votingType={votingType}
        isBlindVoting={isBlindVoting}
        canModerate={canModerate}
        labelOverride={voteLabel}
        showThumbsUp={showThumbsUp}
        maxStars={maxStars}
      />
      {suffix}
    </Styled.VoteSection>
    <IdeaCommentCount count={commentCount} />
  </Styled.Footer>
);
